import FetchFactory from '../factory';
const ENDPOINT_PATH = '/api-electra/Buyback/';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
class BuybackModule extends FetchFactory<any> {
  async getCampaignHero(orderId?: number | null) {
    let url = `${ENDPOINT_PATH}GetCampaignHero`;
    if (orderId && orderId !== -1) {
      url += `?orderId=${orderId}`;
    }
    return await this.call('GET', url);
  }

  async findBuybackItem(maxHits: number, searchTerms: string) {
    const url = `${ENDPOINT_PATH}FindBuybackItem`;
    return await this.call('POST', url, {
      MaxHits: maxHits,
      SearchTerms: searchTerms,
    });
  }
  async getConditionEstimates(
    buybackItemId: number,
    valuateOnly: boolean,
    orderId?: number | null,
  ) {
    const url = `${ENDPOINT_PATH}GetConditionEstimates`;

    return await this.call('POST', url, {
      BuybackItemId: buybackItemId,
      ValuateOnly: valuateOnly,
      OrderId: orderId && orderId !== -1 ? orderId : undefined,
    });
  }

  async valuateDevice(
    condition: string,
    buybackItemId: number,
    downPaymentTime: number | null,
    valuateOnly: boolean,
    orderId?: number | null,
  ) {
    const url = `${ENDPOINT_PATH}ValuateDevice`;

    return await this.call('POST', url, {
      Condition: condition,
      BuybackItemId: buybackItemId,
      DownPaymentTime: downPaymentTime,
      ValuateOnly: valuateOnly,
      OrderId: orderId && orderId !== -1 ? orderId : undefined,
    });
  }
  async addBuybackItemToCart(
    selectedPerkType: string,
    condition: string,
    buybackItemId: number,
    downPaymentTime: number | null,
    valuateOnly: boolean,
  ) {
    const url = `${ENDPOINT_PATH}AddBuybackItemToCart`;
    return await this.call('POST', url, {
      SelectedPerkType: selectedPerkType,
      Condition: condition,
      BuybackItemId: buybackItemId,
      DownPaymentTime: downPaymentTime,
      ValuateOnly: valuateOnly,
    });
  }

  async addBuybackItemToOrder(
    selectedPerkType: string,
    condition: string,
    buybackItemId: number,
    orderId: number,
  ) {
    const url = `${ENDPOINT_PATH}AddBuybackItemToOrder`;
    return await this.call('POST', url, {
      SelectedPerkType: selectedPerkType,
      Condition: condition,
      BuybackItemId: buybackItemId,
      OrderId: orderId,
    });
  }
}

export default BuybackModule;
